module.exports = __webpack_public_path__ + "img/1530729605.47070c08.jpg";